var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"ru:steps"},_vm._l((_vm.steps),function(step,i){return _c('li',{key:i,staticClass:"ru:steps__step"},[_c('ProgressCircle',{staticClass:"ru:steps__progress-circle",attrs:{"progress":step.progress}}),_vm._v(" "),_c('span',{staticClass:"ru:steps__step-text"},[_vm._v("\n      "+_vm._s(step.text)+"\n    ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }